import API from "../../api/apiAdmin";

export const GalleryServices = {
    getAllItems: async () => {
        const response = await API.get("/admin/gallery/");
        return response.data;
    },

    getItemById: async (id) => {
        const response = await API.get(`/admin/gallery/${id}`);
        return response.data;
    },

    createItem: async (formData) => {
        // formData should be FormData object for file upload
        const response = await API.post("/admin/gallery/", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    },

    updateItem: async (id, data) => {
        // If data is FormData, send as multipart/form-data
        if (data instanceof FormData) {
            const response = await API.put(`/admin/gallery/${id}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        }

        const response = await API.put(`/admin/gallery/${id}`, data);
        return response.data;
    },

    deleteItem: async (id) => {
        const response = await API.delete(`/admin/gallery/${id}`);
        return response.data;
    }
};
